"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _constants = _interopRequireDefault(require("@ahmdigital/constants"));
var _fp = require("lodash/fp");
var _moment = _interopRequireDefault(require("moment"));
var _getMelbourneTimezoneAbbreviation = _interopRequireDefault(require("../get-melbourne-timezone-abbreviation"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TIME_FORMAT = {
  ORIGINAL: 'HH:mm',
  TARGET: 'h:mma',
  TARGET_NO_MINUTES: 'ha'
};
var getOpeningHoursString = function getOpeningHoursString(hours, tz) {
  return "".concat(hours.from, " \u2013 ").concat(hours.to, " ").concat(hours.openingDays, " (").concat(tz, ")");
};
var getFormattedHours = function getFormattedHours(hours) {
  return (0, _fp.mapValues)(function (hour) {
    var originalFormatDate = (0, _moment["default"])(hour, TIME_FORMAT.ORIGINAL);
    var dateFormatType = originalFormatDate.minutes() ? TIME_FORMAT.TARGET : TIME_FORMAT.TARGET_NO_MINUTES;
    return originalFormatDate.isValid() ? originalFormatDate.format(dateFormatType) : hour;
  }, hours);
};
var getArrayOfOpeningHours = function getArrayOfOpeningHours(openingHours, tz) {
  return (0, _fp.map)(function (hours) {
    return getOpeningHoursString(getFormattedHours(hours), tz);
  }, openingHours);
};

/**
 * Retrieves contact hours, derived from the values in constants UI file under CONTACT.HOURS.
 * The constants will either be a single object or array of objects.
 *
 * @param {string} key - Service key.
 * @param {string } combinator - String to be inserted between each opening-hours statement.
 * @returns {string} Opening hours in a string format. If an array of dates, the string will
 * append each date, separated by a new-line value.
 * @throws KeyError.
 */
var getOpeningHours = function getOpeningHours(key, combinator) {
  var _constants$UI$CONTACT, _constants$UI;
  var openingHours = (_constants$UI$CONTACT = _constants["default"] === null || _constants["default"] === void 0 || (_constants$UI = _constants["default"].UI) === null || _constants$UI === void 0 || (_constants$UI = _constants$UI.CONTACT) === null || _constants$UI === void 0 || (_constants$UI = _constants$UI.HOURS) === null || _constants$UI === void 0 ? void 0 : _constants$UI[key]) !== null && _constants$UI$CONTACT !== void 0 ? _constants$UI$CONTACT : null;
  if ((0, _fp.isNull)(openingHours)) {
    throw new Error("Key ".concat(key, " is undefined"));
  }
  var tz = (0, _getMelbourneTimezoneAbbreviation["default"])();
  if ((0, _fp.isArray)(openingHours)) {
    return (0, _fp.join)(combinator ? " ".concat(combinator, " ") : '\n', getArrayOfOpeningHours(openingHours, tz));
  }
  return getOpeningHoursString(getFormattedHours(openingHours), tz);
};
var _default = exports["default"] = getOpeningHours;
module.exports = exports.default;